import React from 'react';
import styles from './LoadingOverlay.module.scss';

/**
 * ── Reimplemented LoadingOverlay + ProgressIndicator (documented gap) ───────
 *
 * eb-ui used `@eventbrite/eds-loading-overlay` (white 85% scrim + a circular
 * indeterminate `eds-progress-indicator`). Marmalade has no spinner /
 * progress-indicator (documented gap — see memory.md), and the eds packages are
 * React-16-era. We faithfully reimplement the circular indeterminate spinner
 * inside a semi-transparent white overlay, matching eb-ui's default
 * `size="large-thin"` / `shape=circular` / `type=indeterminate` /
 * `style=gradient`.
 */

export interface LoadingOverlayProps {
    isShown?: boolean;
}

export const LoadingOverlay: React.FunctionComponent<LoadingOverlayProps> = ({
    isShown = false,
}) => {
    if (!isShown) {
        return null;
    }

    return (
        <div className={styles.overlay} data-spec="eds-loading-overlay">
            <div className={styles.indicator} data-testid="progress-indicator">
                <svg
                    className={styles.spinner}
                    viewBox="0 0 50 50"
                    width="48"
                    height="48"
                    role="progressbar"
                    aria-label="Loading"
                >
                    <circle
                        className={styles.track}
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="4"
                    />
                    <circle
                        className={styles.arc}
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="4"
                    />
                </svg>
            </div>
        </div>
    );
};
